"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/InfoIconSolid.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var InfoIconSolid = function InfoIconSolid(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 198.87 198.87"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Solid Info Icon"), _react2.default.createElement("path", {
    className: "info",
    d: "M99.43 0a99.44 99.44 0 1 0 99.44 99.44A99.43 99.43 0 0 0 99.43 0zm10.41 161.68H89V75.56h20.82v86.12zM111.6 55.5a13.69 13.69 0 0 1-7.13 6.92 13 13 0 0 1-5.21 1 12.49 12.49 0 0 1-5.08-1A13.46 13.46 0 0 1 90 59.61a13.6 13.6 0 0 1-2.81-4.11 12.2 12.2 0 0 1-1-5 13 13 0 0 1 1-5.2A13.32 13.32 0 0 1 90 41.06a13.5 13.5 0 0 1 4.16-2.81 12.52 12.52 0 0 1 5.08-1 13 13 0 0 1 5.21 1 13.9 13.9 0 0 1 4.24 2.81 13.55 13.55 0 0 1 2.9 4.2 12.59 12.59 0 0 1 1.09 5.2 11.82 11.82 0 0 1-1.07 5.03z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = InfoIconSolid;